export default __webpack_public_path__ + "static/media/userOrdersDark.b3b470e2.svg";